export default {
  login_register: 'Login/Registrieren',
  booking_confirmation_title: 'Buchungsbestätigung',
  booking_confirmation_body: 'Vielen Dank für die Buchung. Die Bestätigungsdetails stehen weiter unten.',
  insurance_requirements_modal_disclaimer: `Mit dieser Buchung bestätige ich Folgendes: Ich hatte in den letzten 5 Jahren keine Verurteilungen oder Verstöße gegen das Straßenverkehrsrecht. Ich habe keinen Vorschlag abgelehnt, eine Police storniert oder die Verlängerung abgelehnt oder musste eine erhöhte Prämie zahlen oder hatte von einem Kfz-Versicherer besondere Bedingungen auferlegt. Ich wurde nicht vom Fahren ausgeschlossen. Ich habe keine Strafverfolgung oder polizeiliche Untersuchung anhängig. Ich habe keine Verurteilungen wegen Straftaten im Zusammenhang mit Diebstahl, Betrug oder Unehrlichkeit in den letzten 5 Jahren. Ich habe nicht an Seh- oder Hörstörungen (nicht durch Brille oder Hörgerät korrigiert), Herzerkrankungen, Diabetes, Anfällen oder körperlichen oder geistigen Gebrechen jeglicher Art gelitten. Ich habe in den letzten 5 Jahren keine Unfälle gehabt. Bitte klicken Sie {0}, wenn Sie diese Anforderungen nicht erfüllen`,
  insurance_requirements_here: 'hier',
  insurance_requirements: `Ich habe gelesen und bin damit einverstanden, dass ich die {0}`,
  ir: 'Versicherungsbedingungen Erfülle',
  location: 'Ort',
  pickup_location: 'Abholungsort',
  dropoff_location: 'Zustellungsort',
  vehicle: 'Fahrzeug',
  pickup_and_dropoff: 'Abholung und Zustellung (örtliche Zeit)',
  distance_allowance: 'Kilometerbegrenzung',
  view_voucher: 'Gutschein ansehen',
  view_more_bookings: 'Mehr Buchungen ansehen',
  identity_verification_body: 'Sie werden Ihre Identität nachweisen müssen, bevor Sie das Fahrzeug nehmen können',
  identity_verification_title: 'Identität nachweisen',
  search_again: 'Erneut suchen',
  not_available: 'Drive &amp; Go ist momentan nur für Personen mit geprüfter Identitäts- und Führerschein-Dokumenten aus {profiles} verfügbar, aber wir fügen fortwährend weitere Länder hinzu.',
  check_if_included: 'Sehen Sie nach, ob Ihr Land dabei ist',
  included_in_booking: 'Bei dieser Buchung enthalten',
  cdw_with_excess: 'Schadenersatzverzichtklausel bei Kollisionen mit Selbstbehalt',
  theft_protection: 'Diebstahlschutz mit Selbstbehalt',
  risk_reduction: 'Risikoreduktion',
  free_extras: 'Bei dieser Buchung haben Sie Anspruch auf <br /> zwei kostenlose Extras.',
  total_cost: 'Gesamtmietkosten',
  continue: 'Fortfahren',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'S',
  luggage_large_long_label: 'groß',
  luggage_medium_long_label: 'mittelgroß',
  luggage_small_long_label: 'klein',
  fuel_unspecified_label: 'nicht spezifiziert',
  transmission_manual_label: 'Manuell',
  transmission_automatic_label: 'Automatisch',
  make_a_booking: 'Eine Buchung tätigen',
  pickup_date: 'Abholungsdatum',
  dropoff_date: 'Zustellungsdatum',
  driver_age: 'Fahrer zwischen 30 - 65',
  enter_driver_age: 'Bitte das Alter des Fahrers eingeben',
  promo_code: 'Promo-Code',
  search: 'Suchen',
  dropoff_date_cannot_be_before_pickup_date: 'Das Zustellungsdatum kann nicht vor dem Abholungsdatum liegen',
  pickup_date_cannot_be_in_the_past: 'Das Abholungsdatum kann nicht in der Vergangenheit liegen',
  pickup_time_cannot_be_in_the_past: 'Der Abholungszeitpunkt kann nicht in der Vergangenheit liegen',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Der Zustellungszeitpunkt muss später als der Abholungszeitpunkt sein, wenn es sich um den gleichen Tag handelt',
  vehicle_filters: 'Fahrzeugfilter',
  reset: 'Zurücksetzen',
  transmission: 'Getriebe',
  all: 'Alles',
  manual: 'Manuell',
  auto: 'Automatisch',
  passengers: 'Passagiere',
  vehicle_type: 'Fahrzeugart',
  filter: 'Filter',
  vehicle_search: 'Fahrzeugsuche',
  edit: 'Bearbeiten',
  no_results: 'Es gibt keine Ergebnisse für die gewählten Suchkriterien.',
  small_cars: 'Kleine Autos',
  medium_cars: 'Mittelgroße Autos',
  large_cars: 'Große Autos',
  estate_cars: 'Kombiwagen',
  suvs: 'SUVs',
  mpvs: 'Minivans',
  vans: 'Transporter',
  camper_vans: 'Wohnmobil',
  premium: 'Premium',
  unspecified: 'nicht spezifiziert',
  large: 'groß',
  medium: 'mittelgroß',
  small: 'klein',
  automatic: 'automatisch',
  you_have_been_refunded: 'Sie haben eine Rückerstattung erhalten.',
  please_customer_service: 'Bitte kontaktieren Sie unseren Kundendienst, um eine Buchung zu tätigen.',
  contact_customer_service: 'Kundendienst kontaktieren',
  booking_failed: 'Ihre Buchung konnte zu diesem Zeitpunkt nicht verarbeitet werden.',
  summary: 'Zusammenfassung',
  reforestation_and_protection: 'Unterstützen Sie Aufforstung und Schutz des Regenwaldes in Costa Rica',
  cost_of_rental: 'Mietkosten',
  to_pay_now: 'Jetzt zu bezahlen',
  greenheart_donation: 'Grünes-Herz-Spende',
  green_heart_donation: 'Grünes-Herz-Spende',
  tc_agreement: 'Ich habe die {0} gelesen und verstanden.',
  tc: 'Geschäftsbedingungen',
  receive_offers: 'Ich würde gerne besondere Angebote per E-Mail erhalten.',
  donate: 'Ja, ich würde gerne spenden {amount}',
  pay_now: 'Jetzt {amount} bezahlen',
  driver_details: 'Fahrerdaten',
  complete_driver_details: 'Bitte vervollständigen Sie die Fahrerdaten.',
  are_you_the_driver: 'Sind Sie der Fahrer?',
  have_an_account: 'Haben Sie bereits ein Konto?',
  login: 'Anmeldung',
  or: 'oder',
  first_name: 'Vorname des Fahrers',
  last_name: 'Nachname des Fahrers',
  email: 'E-Mail-Adresse',
  phone_number: 'Mobiltelefonnummer',
  unable_to_save_driver_information: 'Die Fahrerdaten können nicht gespeichert werden. Bitte erneut versuchen.',
  pay_on_arrival: 'Bei Ankunft bezahlen',
  pay_online_now: 'Jetzt online bezahlen',
  day: 'Tag',
  choose_location: 'Einen Ort wählen',
  location_not_found: 'Leider konnten wir den von Ihnen gewünschten Ort nicht finden.',
  add: 'Hinzufügen',
  remove: 'Entfernen',
  free_extra: 'Gratis-Extra',
  free: 'GRATIS!',
  fast_track_notice: 'Für diesen Dienst gelten Dokumentenherkunfts-Beschränkungen. Nur verfügbar für Personen mit Dokumenten aus',
  complete_booking: 'Buchung abschließen',
  choose_card: 'Bitte wählen Sie eine Karte oder fügen Sie eine neue hinzu.',
  add_billing_details: 'Bitte fügen Sie Daten für die Rechnungsstellung hinzu.',
  card_number: 'Kartennummer',
  card_holder_name: 'Name des Karteninhabers',
  card_exp: 'MM / JJ',
  card_cvc: 'Sicherheitscode',
  save_card: 'Karte speichern?',
  amount_charged: 'Ihre Karte wird belastet',
  payment_confirmation: 'Buchung bestätigen und bezahlen',
  payment_methods: 'verfügbare Zahlungsarten',
  use_saved_card: 'x gespeicherte Karte verwenden',
  use_different_card: '+ eine andere Karte verwenden',
  book_now: 'Zahlungspflichtig reservieren',
  minimum_age: 'Mindestalter {age} Jahre',
  excess_liability: 'Haftpflichtversicherung mit Ausfalldeckung',
  security_deposit: 'Kaution',
  fuel_policy: 'Treibstoff-Richtlinie',
  like_for_like: 'LFL',
  full_to_full: 'Voll abholen, voll abgeben',
  miles_per_rental: '{mileage} kostenlosen Meilen pro Mietwagen',
  km_per_rental: '{mileage} kostenlosen km pro Mietwagen',
  unlimited: 'Unbegrenzt',
  unlimited_mileage: 'Unbegrenzte Reichweite',
  unlimited_mileage_km: 'Unbegrenzte km',
  non_amendable: 'Nicht ergänzungsfähig',
  non_refundable: 'Nicht erstattbar',
  free_cancellation_until: 'Kostenlose Stornierung bis',
  cancellation_in_line_with: 'Stornierung in Übereinstimmung mit',
  tcs: 'Geschäftsbedingungen',
  free_extras_on_collection: 'Zwei Gratis-Extras bei Abholung',
  glass_and_tyres_covered: 'Glas und Reifen versichert',
  number_of_passengers: 'Anzahl der Passagiere',
  number_of_bags: 'Anzahl der Gepäckstücke',
  fuel_type: 'Treibstoffart',
  co2: 'CO2',
  aircon: 'Klimaanlage',
  refrigeration: 'Gekühlt',
  book_type: 'Buchen {type}',
  processing: 'Verarbeitung',
  actual_price: 'Tatsächlicher Preis',
  tooltip: 'Preis in ${currencyCode} ist eine Schätzung, die auf einem Wechselkurs basiert. Der Preis in ${currency} ist bindend.',
  deposit: 'Anzahlung',
  pay_online: 'Jetzt online bezahlen',
  pay_online_without_extras: 'Mietpreis',
  extras_on_arrival: 'Extras bei Ankunft',
  insurance_on_arrival: 'Risikoreduktion – Bezahlung bei Ankunft',
  insurance_online: 'Risikoreduktion – Sofortbezahlung',
  extras_online: 'Extras sofort zu bezahlen',
  aircon_lower: 'Klimaanlage',
  why_use_drive_and_go: 'Warum Drive & Go verwenden?',
  straight_to_car: 'Direkt zum Auto',
  no_queues: 'Keine Warteschlangen',
  self_checkout: 'Selbst-Check-out',
  cant_lose_key: 'Schlüssel kann nicht verlorengehen',
  online_id_check: 'Online-ID-Prüfung',
  phone_as_key: 'Handy als Schlüssel',
  premiumplus_benefits_includes: 'Premium Plus+ Vorteile auch inklusive',
  book_drive_go: 'Drive & Go buchen',
  duration: 'Dauer',
  to_pay_on_arrival: 'Bei Ankunft zu bezahlen',
  return_date: 'Rückgabedatum',
  postcode: 'Postleitzahl',
  country: 'Land',
  my_profile: 'Mein Profil',
  additional_options: 'Weitere Optionen',
  booking_details: 'Daten bestätigen',
  price_for_x_days: 'Preis für {qty_of_days} Tag | Preis für {qty_of_days} Tage',
  cancelled: 'Abgebrochen',
  upcoming: 'Bevorstehend',
  active: 'Aktiv',
  drive_and_go: {
    drive_and_go: 'Drive & Go',
    available_countries: 'Drive &amp; Go ist momentan nur für Personen mit Identitäts- und Führerschein-Dokumenten aus folgenden Ländern verfügbar:',
    drive_and_go_today: 'Jetzt Drive & Go buchen!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Warum Drive & Go verwenden?',
    straight_to_car: 'Direkt zum Auto',
    no_queues: 'Keine Warteschlangen',
    self_checkout: 'Selbst-Check-out',
    cannot_lose_the_key: 'Schlüssel kann nicht verlorengehen',
    online_id_check: 'Online-ID-Prüfung',
    phone_as_a_key: 'Handy als Schlüssel',
    premium_plus_benefits_also_included: 'Premium Plus+ Vorteile auch inklusive',
    book_drive_and_go: 'Drive & Go buchen'
  },
  my_bookings: 'Meine Buchungen',
  no_bookings: 'Keine Buchungen',
  no_bookings_to_display: 'Keine Buchungen zum Anzeigen.',
  search_great_car_rental_deals: 'Search great car rental deals for your next trip.',
  odometer_at_collection: 'Kilometerzähler bei Abholung',
  fuel_at_collection: 'Treibstoff bei Abholung',
  start_check_in: 'Check-in starten',
  start_collection: 'Abholung starten',
  recent_bookings: 'Meine Buchungen',
  damage: {
    updated_damage_report_submitted: 'Ein aktualisierter Schadensbericht wurde eingereicht. Ein Mitglied unseres Kundendienstes wird Kontakt aufnehmen, falls notwendig.',
    add_additional_damage: 'Zusätzlichen Schaden hinzufügen',
    you_may_report_additional_damage_up_to: 'Sie können innerhalb von 24 Stunden nach dem Fahrzeug-Check-out zusätzlichen Schaden melden',
    specify_damage: 'Schaden angeben',
    please_choose_the_area_and_type_of_damage: 'Bitte wählen Sie den Schadensbereich und die Schadensart.',
    type_of_damage: 'Schadensart',
    is_this_more_than_5_cm: 'Sind es mehr als 5 cm?',
    please_take_or_select_a_photo: 'Bitte nehmen Sie ein Foto auf oder wählen sie eins aus.',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Bitte nehmen Sie ein Foto auf und stellen Sie sicher, dass der Schaden deutlich sichtbar ist.',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Falls erforderlich, können Sie ein weiteres Foto hinzufügen. Bitte wählen Sie das Symbol aus, um ein weiteres Foto auszuwählen.',
    save_image: 'Bild speichern',
    save_images: 'Bilder speichern',
    damage_saved_successfully: 'Schaden erfolgreich gespeichert',
    add_photo: 'Foto hinzufügen'
  },
  checkout: {
    start_collection: 'Abholung starten',
    collect_vehicle: 'Fahrzeug abholen',
    we_will_let_you_know_the_details: 'Sie können sich den Fahrzeugstandort anzeigen lassen, um das Fahrzeug besser zu finden.',
    inspect: 'Inspizieren',
    we_will_ask_for_four_photos_from_each_corner: 'Wir bitten um vier Fotos von jeder Ecke des Fahrzeugs zusammen mit jeglichem neuen Schaden, der nicht bereits aufgeführt ist.',
    fuel_and_milage: 'Tankfüll- & Kilometerstand',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Bestätigen Sie den Tankfüll- und Kilometerstand vor Antritt der Buchung.',
    sign: 'Unterschreiben',
    sign_the_rental_agreement: 'Unterschreiben Sie die Mietvereinbarung.',
    away_you_go: 'Das war‘s schon',
    you_are_free_to_take_to_the_road: 'Schon sind sie abfahrbereit!',
    collect_your_vehicle: 'Ihr Fahrzeug abholen',
    get_directions: 'Wegbeschreibung abrufen',
    hide_directions: 'Wegbeschreibung ausblenden',
    local_time: 'örtliche Zeit',
    tel: 'Tel.',
    getting_to_the_location: 'Zum Ort gelangen',
    get_vehicle_details: 'Fahrzeugdaten abrufen',
    view_map: 'Karte anzeigen',
    unlock_vehicle_and_continue: 'Fahrzeug aufschließen & fortfahren',
    unable_to_connect_to_vehicle: 'Verbindung zum Fahrzeug nicht möglich',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Wir konnten keine Verbindung zum Fahrzeug herstellen - bitte stellen Sie sicher, dass Sie direkt neben dem Fahrzeug stehen, und probieren Sie es erneut.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Wir konnten die Fahrzeugbuchung nicht finden. Bitte später erneut versuchen.',
    odometer_and_fuel: 'Kilometer- & Tankfüllstand',
    odometer: 'Kilometerzähler',
    please_confirm_the_odometer_and_fuel_readings: 'Wenn möglich, bestätigen Sie bitte den Tankfüllstand und den Kilometerstand.',
    the_odometer_field_is_required: 'Das Kilometerzähler-Feld ist erforderlich',
    and_must_be_greater_than_the_checkout_odometer: '& muss größer sein als der Check-out-Kilometerzähler.',
    confirm: 'Bestätigen',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Wir nehmen Sie ein Foto von jeder Ecke des Fahrzeugs auf.',
    pre_existing_damage: 'Vorhandener Schaden',
    no_pre_existing_damage: 'Kein vorhandener Schaden',
    new_damage: 'Neuer Schaden',
    add_additional_damage: 'zusätzlichen Schaden hinzufügen',
    no_new_damage_to_report: 'Kein neuer Schaden zu melden',
    checkout_complete: 'Check-out abgeschlossen',
    start_rental: 'Vermietung starten',
    congratulations_name_it_is_time_to_take_to_the_road: 'Glückwunsch, {customer_name}, Sie sind schon abfahrbereit!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Wir können das Check-out Ihres Fahrzeugs nicht abschließen.',
    please_do_the_following: 'Bitte probieren Sie folgende Schritte aus.',
    remove_all_belonging_and_lock_the_vehicle: 'Entfernen Sie alle Ihre Gegenstände aus dem Fahrzeug und sperren Sie es ab.',
    lock_vehicle: 'Fahrzeug absperren',
    once_you_have_contacted_customer_services: 'Sobald Sie den Kundendienst kontaktiert haben',
    vehicle_location: 'Fahrzeug-Standort',
    collect_your: 'Holen Sie ab:',
    from: 'Von:',
    key_in_glove_box: 'Ihr Schlüssel befindet sich im Handschuhfach',

    keyholder: {
      not_detected: 'Schlüssel im Schlüsselhalter nicht erkannt',
      not_detected_please_try_again: 'Bitte legen Sie Ihren Schlüssel in den Schlüsselhalter und versuchen Sie es erneut.',

      not_installed: 'Schlüsselhalter nicht installiert',
      not_installed_please_contact_customer_service: 'Der Schlüsselhalter ist nicht installiert. Bitte wenden Sie sich an den Kundendienst.',
    },
    keyring: {
      look_up_failed: 'Suche nach Schlüsselbund fehlgeschlagen',
      look_up_failed_please_contact_customer_service: 'Schlüsselring nachschlagen falsch, bitte wenden Sie sich an den Kundendienst.',
    },
    key: {
      invalid: 'Schlüssel ist ungültig',
      invalid_please_contact_customer_service: 'Ihr Schlüssel ist ungültig, bitte wenden Sie sich an den Kundendienst.',

      expired: 'Schlüssel ist abgelaufen',
      expired__please_contact_customer_service: 'Ihr Schlüssel ist abgelaufen, bitte wenden Sie sich an den Kundendienst.',
    }
  },
  checkin: {
    start_check_in: 'Check-in starten',
    vehicle_location: 'Fahrzeugstandort',
    tell_us_where_you_have_parked: 'Teilen Sie uns mit, wo Sie das Fahrzeug geparkt haben.',
    fuel_and_milage: 'Tankfüll- & Kilometerstand',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Bestätigen Sie den Tankfüll- und Kilometerstand vor dem Beenden der Buchung.',
    inspect: 'Inspizieren',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Wir bitten um vier Fotos von jeder Ecke des Fahrzeugs zusammen mit jeglichem neuen Schaden, der während des Leihzeitraums aufgetreten ist.',
    lock: 'Fahrzeug abschließen',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Stellen Sie sicher, dass Sie keine Gegenstände im Fahrzeug zurückgelassen haben, und schließen Sie es ab.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Bitte teilen Sie uns mit, wo Sie das Fahrzeug geparkt haben.',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Sobald das Fahrzeug abgeschlossen ist, können Sie es nicht wieder aufschließen.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, überprüfen Sie bitte, ob Sie keine Sachen zurückgelassen haben, schließen Sie das Fahrzeug ab und geben Sie den physischen Schlüssel bei Bedarf an den Schlüsselhalter zurück.',
    lock_vehicle: 'Fahrzeug abschließen',
    complete_check_in: 'Fahrzeugrückgabe abschließen',
    inspection: 'Inspektion',
    complete_vehicle_check_in: 'Fahrzeugrückgabe abschließen',
    we_are_unable_to_complete_your_vehicle_check_in: 'Wir können das Check-out Ihres Fahrzeugs nicht abschließen.',
    please_contact_customer_services: 'Bitte kontaktieren Sie den Kundendienst.',
    once_you_have_contacted_customer_services: 'Sobald Sie den Kundendienst kontaktiert haben',
    please_amend_odometer_to_be_greater_than: 'Bitte ändern Sie den Kilometerzähler so, dass er größer als ist {odometer_value}'
  },
  rental_agreement: {
    rental_agreement: 'Mietvertrag',
    agreement_between: 'Vereinbarung zwischen',
    and: 'und',
    sign_rental_agreement: 'Unterschreiben Sie die Mietvertrag',
    i_have_read_and_understood_the_terms_and_conditions: 'Ich habe die Terms & Bedingungen gelesen und verstanden und akzeptiere den Zustand des Fahrzeugs'
  },
  full_insurance_no_deposit: 'Vollkaskoversicherung & keine Kaution erforderlich',
  excess: '{amount} Selbstbeteiligung',
  deposit: '{amount} Kaution',
  included_daily_distance: '{distance} {unit} pro Tag',
  miles: 'Meilen',
  kilometers: 'Kilometer',
  collection_details_title: 'Sammlungsdetails',
  collection_details_not_found: 'Für diesen Speicherort sind keine Sammlungsdetails definiert',
  free_cancellation: 'Kostenlose Stornierung bis',
  no_deposit: 'Keine Anzahlung',
  benefit_from: 'Profitieren von',
  for_only_per_day: 'Für nur {price} pro Tag',
  upgrade_mee: 'UpgradeMee'
}






